import { isValidEmail } from "../../../common-utilities/utils";
import { VENDOR_DOCUMENT_TYPES } from "../vendor-request-details/helper";
import { UDYAM_REG_EX } from "../../../common-utilities/core/udyam-number-input";
import { BC_TEXT_MAX_LENGTH, COUNTRY_LIST } from "../vendor-onboard-form/helper";

export const PHONE_NO_REG_EX = /^\d{10}$/;
export const ALPHA_NUMERIC = /^[a-zA-Z0-9_.-]*$/;
export const PAN_CARD_REG_EX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}/;
export const isFormValid = (formDetails, louRequired = false) => {
  const {
    nameOfLegalEntity,
    email,
    mobile = "",
    gstStatus = "",
    gst = "",
    pan = "",
    cancelledCheque = "",
    focalPointOfContact = "",
    ifsc = "",
    bankName = "",
    line = "",
    street = "",
    city = "",
    pincode = "",
    country = "",
    vendorTenure = "",
    msmeDocument = "",
    msme = "",
    msmeNumber = "",
    msmeNumberIsLegacy = false,
    msmeType = "",
    msmeCategory = "",
    gstDocument = "",
    panCard,
    natureTransaction = "",
    gstDeclaration = "",
    msmeDeclaration = "",
    louDoc = "",
  } = formDetails;
  let error = {};

  if (!isValidEmail(email)) {
    error.email = true;
  }

  if (!mobile || !mobile.match(PHONE_NO_REG_EX)) {
    error.mobile = true;
  }

  if (!ifsc || !ifsc.match(ALPHA_NUMERIC) || ifsc?.length != 11 && ifsc?.length != 12) {
    error.ifsc = true;
  }

  if (!pincode || !pincode.match(ALPHA_NUMERIC)) {
    error.pincode = true;
  }

  if (!bankName) {
    error.bankName = true;
  }
  if (!vendorTenure) {
    error.vendorTenure = true;
  }
  if (!nameOfLegalEntity || nameOfLegalEntity.length > BC_TEXT_MAX_LENGTH) {
    error.nameOfLegalEntity = true;
  }

  if (!line || line.length > BC_TEXT_MAX_LENGTH) {
    error.line = true;
  }

  if (street && street.length > BC_TEXT_MAX_LENGTH) {
    error.street = true;
  }

  if (!city || !city.match(ALPHA_NUMERIC)) {
    error.city = true;
  }

  if (!COUNTRY_LIST.includes(country)) {
    error.country = true;
  }
  if (!gstStatus) {
    error.gstStatus = true;
  }
  if (gstStatus === "Yes" && gst.length !== 3) {
    error.gst = true;
  }
  if (gstStatus === "Yes" && !gstDocument) {
    error.gstDoc = true;
  }
  if (gstStatus === "No" && !gstDeclaration) {
    error.gstDeclaration = true;
  }
  if (!panCard) {
    error.panCard = true;
  }
  if (msme === "Yes" && !msmeDocument) {
    error.msmeDocument = true;
  }
  if (msme === "Yes" && !msmeType) {
    error.msmeType = true;
  }
  if (msme === "Yes") {
    if (msmeNumberIsLegacy) {
      if (!msmeNumber) {
        error.msmeNumber = true;
      }
    } else if (!msmeNumber || !msmeNumber.match(UDYAM_REG_EX)) {
      error.msmeNumber = true;
    }
  }
  if (msme === "Yes" && !msmeCategory) {
    error.msmeCategory = true;
  }
  if (msme === "No" && !msmeDeclaration) {
    error.msmeDeclaration = true;
  }
  if (louRequired && !louDoc) {
    error.louDoc = true;
  }
  if (
    !pan ||
    !pan.match(ALPHA_NUMERIC) ||
    pan.length !== 10 ||
    !pan.match(PAN_CARD_REG_EX)
  ) {
    error.pan = true;
  }

  if (!focalPointOfContact) {
    error.focalPointOfContact = true;
  }

  if (!cancelledCheque) {
    error.cancelledCheque = true;
  }

  if (
    !natureTransaction ||
    (natureTransaction.length < 3 && natureTransaction !== "NA")
  ) {
    error.natureTransaction = true;
  }

  return error;
};

export const NATURE_OF_COMPLAINT = [
  {
    value: "Service",
    label: "Service",
  },
  {
    value: "Supplies",
    label: "Supplies",
  },
];

export const GST_STATUS = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
];

export const formatPayload = (formDetails) => {
  const {
    nameOfLegalEntity,
    email,
    mobile = "",
    alternativeMobile,
    gstStatus = "",
    gst,
    pan = "",
    cancelledCheque = "",
    focalPointOfContact = "",
    typeOfVendor,
    msme,
    msmeNumber,
    accountNumber,
    bankName = "",
    ifsc,
    line,
    street,
    city,
    country,
    pincode,
    state = {},
    panCard = "",
    msmeDocument = "",
    gstDocument = "",
    status,
    formId,
    msmeType,
    msmeCategory,
    department = {},
    creditPeriod,
    attachment,
    vendorTenure,
    natureTransaction,
    gstDeclaration,
    msmeDeclaration,
    louDoc,
  } = formDetails;
  const attachments = [];

  if (gstDocument) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.GST_DOC,
      url: gstDocument,
    });
  }

  if (panCard) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.PAN_CARD,
      url: panCard,
    });
  }
  if (gstDeclaration) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.GST_DECLARATION,
      url: gstDeclaration,
    });
  }
  if (msmeDocument) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.MSME_DOC,
      url: msmeDocument,
    });
  }
  if (msmeDeclaration) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.MSME_DECLARATION,
      url: msmeDeclaration,
    });
  }
  if (louDoc) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.LOU_DOC,
      url: louDoc,
    });
  }
  if (attachment) {
    attachments.push({
      type: VENDOR_DOCUMENT_TYPES.ATTACHMENT,
      url: attachment,
    });
  }

  const payload = {
    email: email,
    bankDetails: {
      accountNumber: accountNumber,
      bankName: bankName,
      ifsc: ifsc,
    },
    address: {
      line: line,
      street: street,
      city: city,
      state: state.value,
      country: country,
      pincode: pincode,
    },
    nameOfLegalEntity: nameOfLegalEntity,
    pan: pan,
    focalPointOfContact: focalPointOfContact,
    mobile: mobile,
    gstStatus: gstStatus,
    gst:
      gstStatus === "Yes"
        ? `${(state && state.code) || ""}${pan || ""}${gst}`
        : "",
    msme: msme,
    msmeNumber: msmeNumber,
    attachments: attachments,
    typeOfVendor: typeOfVendor,
    cancelledCheque: cancelledCheque.url || cancelledCheque,
    status,
    formId,
    msmeType,
    msmeCategory,
    department: department.value,
    vendorTenure,
    creditPeriod,
    natureTransaction,
  };
  if (alternativeMobile) {
    payload.alternativeMobile = alternativeMobile;
  }

  return payload;
};

export const formateSubmittedDetails = (submittedDetails) => {
  const { cancelledCheque = "", attachments = [] } = submittedDetails;
  let details = {
    ...submittedDetails,
  };
  if (cancelledCheque) {
    details.cancelledCheque = {
      url: cancelledCheque,
      blobName: "Cancled Cheque",
    };
  }
  if (attachments.length > 0) {
    const gstDoc = attachments.find((a) => a.type === "GST_DOC");
    if (gstDoc) {
      details.gstDoc = {
        url: gstDoc.url,
        blobName: gstDoc.type,
      };
    }

    const panDoc = attachments.find((a) => a.type === "PAN_CARD");
    if (panDoc) {
      details.panDoc = {
        url: panDoc.url,
        blobName: panDoc.type,
      };
    }
  }

  return details;
};
